import { render } from "./ConsultaPorCodigo.vue?vue&type=template&id=71a388c8&scoped=true"
import script from "./ConsultaPorCodigo.vue?vue&type=script&lang=js"
export * from "./ConsultaPorCodigo.vue?vue&type=script&lang=js"

import "./ConsultaPorCodigo.vue?vue&type=style&index=0&id=71a388c8&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a388c8"]])

export default __exports__